/**
 * Tutorial guidato dell'elenco Coupon.
 *
 * Il piu' in alto porta dritto alla pagina della scheda. I tre pallini della riga
 * si raccontano illuminando il pulsante, non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori. Il pulsante invece c'e' sempre, e il testo dice cosa contiene.
 */
const SCOPE = '[data-tour-scope="coupons"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopCouponsTour() {}

export function createCouponsTourSteps() {
	return [
		{
			body: "Attenzione a cosa sta in questa pagina: non i codici sconto, ma le regole che li fanno nascere. Una riga dice quando un coupon viene emesso, quanto sconta e quanto vale nel tempo; i codici veri stanno nell'elenco a parte, che si apre dal menu della riga.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le regole dei coupon',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina della nuova regola: li' si sceglie l'evento, lo sconto e le condizioni. Annulla riporta qui con l'elenco come l'avevi lasciato. La pagina ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere una regola',
		},
		{
			body: "Ogni riga e' una regola: il nome con il prefisso dei codici, l'evento che la fa scattare con sotto l'utilizzo - Coupon vuol dire che i codici nascono gia' spendibili, Automazione che nascono spenti - lo sconto, la validita' e l'interruttore.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende e spegne la regola, e salva subito. Spenta, la regola smette di emettere codici nuovi: quelli gia' emessi restano validi finche' non li spegni uno per uno nell'elenco dei codici.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Accendere la regola',
		},
		{
			body: "Lo sconto si legge gia' pronto - meno dieci per cento, meno cinque euro - con sotto la soglia d'ordine quando c'e'. Accanto, la validita': le date della regola e quanti giorni vive ogni codice.",
			key: 'discount',
			placement: 'top',
			target: at('discount'),
			title: 'Sconto e validita',
		},
		{
			body: "Il + apre la regola spiegata in una frase, i limiti - quanti codici ha gia' emesso su quanti ne puo' emettere - e a chi o a cosa si applica. Da li' si va anche ai Codici, a Modifica ed Elimina.",
			key: 'expand',
			missing: 'skip',
			placement: 'right',
			target: at('expand'),
			title: 'Come funziona la regola',
		},
		{
			body: "I tre pallini a inizio riga aprono tre voci: Modifica, che porta alla pagina della regola, Elimina, che chiede conferma, e Codici, che porta all'elenco dei codici nati da questa regola - quello dove si vede chi li ha usati e quando.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare, eliminare, vedere i codici',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
